import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faGoogle } from '@fortawesome/free-brands-svg-icons/faGoogle';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
// import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/qcheng-dev',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.linkedin.com/in/qiancheng/',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://twitter.com/DrQianCheng',
    label: 'Twitter',
    icon: faTwitter,
  },
  {
    link: 'https://scholar.google.com/citations?user=nsgrgMMAAAAJ&hl=en',
    label: 'Google Scholar',
    icon: faGoogle,
  },
  // {
  //   link: 'mailto:nicolasqcheng@icloud.com',
  //   label: 'Email',
  //   icon: faEnvelope,
  // },
];

export default data;
